// @flow
import React, { type ElementRef, type Node } from 'react';
import { withRouter } from 'react-router-dom';
// import { type ReactObjRef } from '../utilities/types';
import AnimatingBorder from './AnimatingBorder';

type ReactObjRef<ElementType: React$ElementType> = {
  current: { findActive: () => void } | ElementRef<ElementType>
};

type Props = { location: Location, className?: string, children: Node };
type State = {
  borderLeft: number,
  borderWidth: number,
  transitionActive: boolean
};

class NavTabs extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.animatingBorderRef = React.createRef();
  }
  animatingBorderRef: ReactObjRef<any>;

  componentDidUpdate(prevProps: Props) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      const animatingBorderRef = this.animatingBorderRef.current;
      animatingBorderRef.findActive();
    }
  }

  render() {
    return (
      <AnimatingBorder
        ref={this.animatingBorderRef}
        className={this.props.className}
      >
        {this.props.children}
      </AnimatingBorder>
    );
  }
}

export default withRouter(NavTabs);
